export default "__VITE_ASSET__Ck$yBBND__"